import "../../assets/Input.css";
import { jsxs as h, jsx as i } from "react/jsx-runtime";
import { c as s } from "../../index-LULxUVKG.js";
import { forwardRef as g } from "react";
import { Icon as p } from "../Icon/Icon.js";
const y = "_wrapper_1gyu2_3", d = "_icon_1gyu2_9", S = "_left_1gyu2_13", v = "_right_1gyu2_17", w = "_input_1gyu2_40", N = "_hasLeftSlot_1gyu2_78", x = "_hasRightSlot_1gyu2_82", t = {
  wrapper: y,
  icon: d,
  left: S,
  right: v,
  input: w,
  hasLeftSlot: N,
  hasRightSlot: x
}, k = g(
  ({
    as: _ = "input",
    iconLeft: r,
    iconRight: a,
    rightSlot: e,
    inputClassName: c,
    wrapperClassName: u,
    iconClassName: l,
    "data-error": o,
    "aria-invalid": n,
    ...m
  }, f) => /* @__PURE__ */ h("div", { className: s(t.wrapper, u), children: [
    r ? /* @__PURE__ */ i(
      p,
      {
        className: s(t.icon, t.left, l),
        name: r,
        size: 16,
        pointerEvents: "none",
        "data-error": o,
        "aria-invalid": n
      }
    ) : null,
    /* @__PURE__ */ i(
      _,
      {
        className: s(
          t.input,
          {
            [t.hasLeftSlot]: !!r,
            [t.hasRightSlot]: !!a || !!e
          },
          c
        ),
        "data-error": o,
        "aria-invalid": n,
        ...m,
        ref: f
      }
    ),
    a && !e ? /* @__PURE__ */ i(
      p,
      {
        className: s(t.icon, t.right, l),
        name: a,
        size: 16,
        pointerEvents: "none",
        "data-error": o,
        "aria-invalid": n
      }
    ) : null,
    e
  ] })
);
export {
  k as Input
};
